<template>
  <div class="animated fadeIn">
    <b-card>

      <!-- HEADER -->
        <div id="listloader" v-if="loader">
            <div class="listloader"></div>
        </div>

        <b-row>
            <b-col md="11">
                <b-row class="align-items-center">

            <!-- LABEL -->
            <b-col md="2">
                <label class="mb-0 ml-2"><strong>Search</strong></label>
            </b-col>

            <!-- INPUT -->
            <b-col md="4">
                <b-input-group>
                <b-form-input placeholder="Type to Search" v-model="searchdata"></b-form-input>
                <b-input-group-append>
                    <b-button variant="secondary" @click="cleardata();">Clear</b-button>
                </b-input-group-append>
                </b-input-group>
            </b-col>

            <!-- BUTTONS -->
            <b-col md="4" class="text-right">
                <b-button variant="info" class="mr-2" @click="seachdatafunction();">Search</b-button>
                <b-button variant="danger" class="mr-2" @click="cleardata();">Clear</b-button>
                 <!-- <a :href="loadurl" target="_blank" v-if="totalRows > 0"> -->
                <b-button variant="primary" @click="downloaddata()" v-if="totalRows">Download</b-button>
                <!-- </a> -->
            </b-col>

            </b-row>
            </b-col>

            <b-col md="1">
                <b-button class="ml-auto" size="sm" variant="secondary" @click="goback()"> Back
                </b-button>
            </b-col>
        </b-row>

        <div class="table-container mt-5">

        <!-- TOP RIGHT RECORD COUNT -->
        <div class="text-right mb-1 total-records" style="font-weight: 600;">
            Total Records : <span class="count text-danger" >{{ totalRows }}</span>
        </div>

        <!-- TABLE -->
         <b-table show-empty stacked="xl"  :items="items"  :fields="fields"  :current-page="currentPage"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy" >
  
            <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
            </div>    
        </b-table> 
           <b-col md="12" class="my-1" v-if="items && items.length > 0" >
            <paginate 
            v-model="pageNum"
            :page-count="noofpages"
            :page-range="10"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'">
            </paginate>
        </b-col>

        </div>
    
    </b-card>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
import { EventBus } from "./event-bus.js";
export default{
    
data(){
return{
    hub_id:'',
    cityname:'',
    items:[],
    fields:[],
    isBusy: false,
    outlined: true,
    totalRows: 0,
   
    currentPage: 1,
    pageOptions: [5, 10, 15],
    perPage:  10,
    isCheckAll: false,
    sortDirection: 'asc',
    sortBy: null,
    sortDesc: true,
    filter: null,
    noofpages:'',
    pageNum:1,
    searchdata:"",
    loadurl: '',
    loader:false,
    keyword:'',
    mainkeyword:'',
    loadtype:'',
}

},
created(){
    console.log("INN", this.$route.query)
    this.hub_id = this.$route.query.hubid
    this.cityname = this.$route.query.city
    this.mainkeyword = this.$route.query.mainkeyword
    this.keyword = this.$route.query.keyword
    this.loadtype = this.$route.query.loadtype
    console.log("this.keyword", this.keyword);
    console.log("mainkeyword", this.mainkeyword);
  
    if(this.mainkeyword == 'Todayinfirstfile'){
        this.getfirstmileshipementdata(this.hub_id,this.cityname, this.pageNum);
    }
    else if(this.mainkeyword == 'TodayinMidMile' || this.mainkeyword == 'TodayinLastMile'){
         this.getmidANdlastmileshipmentdetails(this.pageNum);
    }
   
    else{
        this.getcitywaisedata(this.hub_id,this.cityname, this.pageNum);
    }
   
},
methods:{
    goback(){
    this.$router.back()
  },

  getmidANdlastmileshipmentdetails(pageNum){
    // alert()
    this.loader=true;
    const obj ={
        page_no: `${pageNum}`,
        searchdata: this.searchdata,
        hub_id:this.hub_id,
        keyword:this.keyword,
        mainkeyword: this.mainkeyword,
        loadtype: this.loadtype
    }

    this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmidANdlastmileshipmentdetails`, obj)
    .then(result =>{
        this.loader=false;
        if (result.body.returnmsg === 'Successful') {
            // console.log("result.body.returnmsg", result.body.returnvalue);
            this.items = result.body.returnvalue.data
            this.totalRows = result.body.returnvalue.totalcount
            // console.log(" this.totalRows",  this.totalRows)
            // this.noofpages=parseInt(this.totalRows)/20;
            // this.noofpages=Math.ceil( this.noofpages);
            this.noofpages = Math.ceil(this.totalRows / this.perPage);
            let extraFields = [];
            // Common fields (define once)
            const commonFields = [
            {key:'parentawb' , label:'Parent AWB', tdClass: 'text-nowrap'},
            {key:'load_id' , label:'Load Id', tdClass: 'text-nowrap'},
            {key:'warehousename' , label:'Warehouse Name', tdClass: 'text-nowrap'},
            {key:'warehouseid' , label:'Warehouse ID'},
            {key:'invoicevalue' , label:'Invoice Value'},
            {key:'weight' , label:'Weight'},
            {key:'mpscount' , label:'MPS Count'},
            {key:'shipmentstatus' , label:'Shipment Status', tdClass: 'text-nowrap'},
            {key:'destinationaddress' , label:'Destination Address', tdClass: 'wrap-text'},
            {
                key:'createddate',
                label:'Created Date',
                formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : '',
                tdClass: 'text-nowrap'
            },
            {
                key:'hubinscandate',
                label:'Hub In Scan Date',
                formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                tdClass: 'text-nowrap'
            }
            
            ]

            if(this.keyword == 'HubInScan'){
                extraFields=[
                {
                    key:'edd',
                    label:'EDD',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                },
                ]
            }
            else if(this.keyword == 'ZoneInScan/DockInScan'){
                extraFields=[
                {
                    key:'zoneinscandate',
                    label:'Zone In Scan Date',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                }, 
                {
                    key:'edd',
                    label:'EDD',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                },  
                 ]
            }
            else if(this.keyword == 'ZoneOutScan/DockOutScan'){
                extraFields=[
                {
                    key:'zoneinscandate',
                    label:'Zone In Scan Date',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                }, 
                {
                    key:'zoneoutscandate',
                    label:'Zone Out Scan Date',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                }, 
                {
                    key:'edd',
                    label:'EDD',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                },  
                 ]
            }
            else if(this.keyword == 'INTransit'){
                extraFields=[
                {
                    key:'dispatchoutscandate',
                    label:'Dispatch Out Scan Date',
                    formatter: value =>
                    value
                        ? new Date(value).toLocaleString('en-IN', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                            hour12: true // change to false for 24-hour format
                        })
                        : 'NA',
                    tdClass: 'text-nowrap'
                }, 
                {
                    key:'lastmodifieddate',
                    label:'Intransit Date',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                }, 
                {
                    key:'vehicle_no',
                    label:'Vehicle Number',
                    formatter: value => value || 'NA',
                    tdClass: 'text-nowrap'
                },
                {
                    key:'edd',
                    label:'EDD',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                },  
               ]
            }
            else if(this.keyword == 'DispatchOutScan'){
                extraFields=[
                {
                    key:'zoneinscandate',
                    label:'Zone In Scan Date',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                }, 
                {
                    key:'zoneoutscandate',
                    label:'Zone Out Scan Date',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                }, 
                {
                    key:'dispatchoutscandate',
                    label:'Dispatch Out Scan Date',
                    formatter: value =>
                    value
                        ? new Date(value).toLocaleString('en-IN', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                            hour12: true // change to false for 24-hour format
                        })
                        : 'NA',
                    tdClass: 'text-nowrap'
                }, 
             
                {
                    key:'vehicle_no',
                    label:'Vehicle Number',
                    formatter: value => value || 'NA',
                    tdClass: 'text-nowrap'
                },
                {
                    key:'edd',
                    label:'EDD',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                },  
               ]
            }


            this.fields = [...commonFields, ...extraFields ];
        }else{
            this.items =[]
            this.totalRows =0
        }
    })

  },

  getfirstmileshipementdata(hubid, city,pageNum){
    this.loader=true;
    const obj ={
        page_no: `${pageNum}`,
        searchdata: this.searchdata,
        keyword:this.hub_id,
        mainkeyword: this.mainkeyword,
        loadtype: this.loadtype
    }

    this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getfirstmileshipementdata`, obj)
    .then(result =>{
        this.loader=false;
        if (result.body.returnmsg === 'Successful') {
            // console.log("result.body.returnmsg", result.body.returnvalue);
            this.items = result.body.returnvalue
            this.totalRows = result.body.returnvalue[0].totalcount
            //this.noofpages=parseInt(this.totalRows)/20;
            this.noofpages = Math.ceil(this.totalRows / this.perPage);
            let extraFields = [];
            // Common fields (define once)
            const commonFields = [
            {key:'parentawb' , label:'Parent AWB', tdClass: 'text-nowrap'},
            {key:'load_id' , label:'Load Id', tdClass: 'text-nowrap'},
            {key:'warehousename' , label:'Warehouse Name', tdClass: 'text-nowrap'},
            {key:'warehouseid' , label:'Warehouse ID'},
            {key:'invoicevalue' , label:'Invoice Value'},
            {key:'weight' , label:'Weight'},
            {key:'mpscount' , label:'MPS Count'},
            {key:'shipmentstatus' , label:'Shipment Status', tdClass: 'text-nowrap'},
            {key:'destinationaddress' , label:'Destination Address', tdClass: 'wrap-text'},
            {
                key:'createddate',
                label:'Created Date',
                formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : '',
                tdClass: 'text-nowrap'
            }
            ]
            if(this.keyword == 'BookingPending'){
                this.fields = [...this.commonFields]
            }
            else if(this.keyword == 'BookingDone')
            {   
                extraFields = [
                    {
                    key:'whdispatcheddate',
                    label:'WH Dispatch Date Time',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                    },
                    {
                    key:'vehicle_no',
                    label:'Vehicle Number',
                    formatter: value => value || 'NA',
                    tdClass: 'text-nowrap'
                    },
                    {
                    key:'booking_done_date',
                    label:'Booking Done Date Time',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                    },
                    {
                    key:'edd',
                    label:'EDD',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                    },
                ]
            }
             else if(this.keyword == 'PickDone')
            {   
                extraFields = [
                {
                    key:'whdispatcheddate',
                    label:'WH Dispatch Date Time',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                },
                {
                    key:'vehicle_no',
                    label:'Pickdone Vehicle Number',
                    formatter: value => value || 'NA',
                    tdClass: 'text-nowrap'
                },
                {
                    key:'booking_done_date',
                    label:'Booking Done Date Time',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                },
                {
                    key:'pickupdatetime',
                    label:'Pickup Date Time',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                },
                {
                    key:'edd',
                    label:'EDD',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                },
                   
                ]
            }
            else if(this.keyword == 'HubInScanPending')
            {   
                extraFields = [
                {
                    key:'whdispatcheddate',
                    label:'WH Dispatch Date Time',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                },
                {key:'lastdisptchhubname' , label:'Hub Name', tdClass: 'text-nowrap'},
                {
                    key:'edd',
                    label:'EDD',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                },
                   
                ]
            }
             else if(this.keyword == 'NPR')
            {   
                extraFields = [
                {
                    key:'whdispatcheddate',
                    label:'WH Dispatch Date Time',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                },
                {
                    key:'vehicle_no',
                    label:'Vehicle Number',
                    formatter: value => value || 'NA',
                    tdClass: 'text-nowrap'
                },
                {
                    key:'booking_done_date',
                    label:'Booking Done Date Time',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                },
                {
                    key:'pickupdatetime',
                    label:'Pickup Date Time',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                },
                {
                    key:'nprdate',
                    label:'NPR Date Time',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                },
                 {
                    key:'pickupstatus',
                    label:'NPR Reason',
                    tdClass: 'text-nowrap'
                },
                {
                    key:'edd',
                    label:'EDD',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                    tdClass: 'text-nowrap'
                },
                   
                ]
            }
            
            this.fields = [...commonFields, ...extraFields];
        }
        else{
             this.items = []
        }   
    })
  },
  
  getcitywaisedata(hub_id, city, pageNum){
    const obj ={
        hub_id,
        city,
        page_no: `${pageNum}`,
        searchdata: this.searchdata,
        keyword:this.keyword,
        mainkeyword: this.mainkeyword,
        loadtype: this.loadtype
    }

    this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getcitywisedatatodaydelivered`, obj)
    .then(result =>{
        if (result.body.returnmsg === 'Successful') {
            // console.log("result.body.returnmsg", result.body.returnvalue);
            this.items = result.body.returnvalue
            this.totalRows = result.body.returnvalue[0].totalcount
           // this.noofpages=parseInt(this.totalRows)/20;
            //this.noofpages=Math.ceil( this.noofpages);
            this.noofpages = Math.ceil(this.totalRows / this.perPage);
           let extraFields = [];
           // Common fields (define once)
            const commonFields = [
            {key:'parentawb' , label:'Parent AWB', tdClass: 'text-nowrap'},
            {key:'load_id' , label:'Load Id', tdClass: 'text-nowrap'},
            {key:'warehousename' , label:'Warehouse Name', tdClass: 'text-nowrap'},
            {key:'warehouseid' , label:'Warehouse ID'},
            {key:'invoicevalue' , label:'Invoice Value'},
            {key:'weight' , label:'Weight'},
            {key:'mpscount' , label:'MPS Count'},
            {key:'shipmentstatus' , label:'Shipment Status', tdClass: 'text-nowrap'},
            {key:'lastdisptchhubname' , label:'Last Disptch Hub Name', tdClass: 'text-nowrap'},
            {key:'destinationaddress' , label:'Destination Address', tdClass: 'wrap-text'},
            {
                key:'createddate',
                label:'Created Date',
                formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : '',
                tdClass: 'text-nowrap'
            }
            ];

            if (this.mainkeyword === 'TodaysDelivered') {
            extraFields = [
                {
                key:'ofddate',
                label:'OFD Date time',
                formatter: value => value ? new Date(value).toLocaleString('en-IN') : '',
                tdClass: 'text-nowrap'
                },
                {
                key: 'delivery_date',
                label: 'Delivery Date',
                formatter: value =>
                    value
                        ? new Date(value).toLocaleString('en-IN', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                            hour12: true // change to false for 24-hour format
                        })
                        : 'NA',
                tdClass: 'text-nowrap'
            },
                {
                key:'edd',
                label:'EDD',
                formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                tdClass: 'text-nowrap'
                },
                {key:'deliveredthrough', label:'Delivered Through', tdClass: 'text-nowrap'}
            ];
            }
            else if (this.mainkeyword === 'TodayinReturnJourney') {
            extraFields = [
                {
                    key:'hubinscandate',
                    label:'Hub InScan Date Time',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : '',
                    tdClass: 'text-nowrap'
                },
                {
                    key:'dispatchoutscandate',
                    label:'Dispatch Out Scan Date Time',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : '',
                    tdClass: 'text-nowrap'
                },
                {
                    key:'lastmodifieddate',
                    label:'RTO Date Time',
                    formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : '',
                    tdClass: 'text-nowrap'
                },
                {
                    key:'vehicle_no',
                    label:'Vehicle Number',
                    formatter: value => value || 'NA',
                    tdClass: 'text-nowrap'
                }
            ];
            }

            // Merge both
            this.fields = [...commonFields, ...extraFields];
                    }
                    else{
                        this.items =[]
                        this.totalRows =0
                    }
                })
            },

    clickCallback (pageNum){
        // this.getcitywaisedata(pageNum);

            if(this.mainkeyword == 'Todayinfirstfile'){
                this.getfirstmileshipementdata(this.hub_id,this.cityname, pageNum);
            }
            else if(this.mainkeyword == 'TodayinMidMile' || this.mainkeyword == 'TodayinLastMile'){
                this.getmidANdlastmileshipmentdetails(pageNum);
            }
        
            else{
                this.getcitywaisedata(this.hub_id,this.cityname, pageNum);
            }
    },

    cleardata(){
        this.searchdata ='';
        this.pageNum = 1
        // this.getcitywaisedata(this.hub_id,this.cityname, this.pageNum);

        if(this.mainkeyword == 'Todayinfirstfile'){
            this.getfirstmileshipementdata(this.hub_id,this.cityname, this.pageNum);
        }
        else if(this.mainkeyword == 'TodayinMidMile' || this.mainkeyword == 'TodayinLastMile'){
            this.getmidANdlastmileshipmentdetails(this.pageNum);
        }
    
        else{
            this.getcitywaisedata(this.hub_id,this.cityname, this.pageNum);
        }
    },

    seachdatafunction(){
        this.pageNum = 1
        //  this.getcitywaisedata(this.hub_id,this.cityname, this.pageNum);

        if(this.mainkeyword == 'Todayinfirstfile'){
            this.getfirstmileshipementdata(this.hub_id,this.cityname, this.pageNum);
        }
        else if(this.mainkeyword == 'TodayinMidMile' || this.mainkeyword == 'TodayinLastMile'){
            this.getmidANdlastmileshipmentdetails(this.pageNum);
        }
    
        else{
            this.getcitywaisedata(this.hub_id,this.cityname, this.pageNum);
        }
    },

    downloaddata(){ 
        //   keyword:this.keyword,
        // mainkeyword: this.mainkeyword
        // alert(this.mainkeyword)
        this.loader = true;
        if(this.mainkeyword == 'TodaysDelivered' || this.mainkeyword == 'TodayinReturnJourney'){
            this.loadurl = `${CONSTANTS.MISREPORT_API_URL}/downloadcitywisedataOP?hub_id=${this.hub_id}&city=${this.cityname}&searchdata=${this.searchdata}&keyword=${this.keyword}&mainkeyword=${this.mainkeyword}$loadtype=${this.loadtype}`;
        }
        else if(this.mainkeyword == 'Todayinfirstfile'){
            
            this.loadurl = `${CONSTANTS.MISREPORT_API_URL}/downloadfirstmilecsvdata?searchdata=${this.searchdata}&keyword=${this.keyword}&mainkeyword=${this.mainkeyword}`;
        
        }
        else{
            
             this.loadurl = `${CONSTANTS.MISREPORT_API_URL}/downloadmidAndLastmilecsv?hub_id=${this.hub_id}&searchdata=${this.searchdata}&keyword=${this.keyword}&mainkeyword=${this.mainkeyword}`;
        }
        // searchdata: this.searchdata,
        // hub_id:this.hub_id,
        // keyword:this.keyword,
        // mainkeyword: this.mainkeyword
        // 🔥 trigger download (ONLY href, no download attr)
        const link = document.createElement('a');
        link.href = this.loadurl;
        document.body.appendChild(link);
        link.click();
        link.remove();

        // loader stop (approx)
        setTimeout(() => {
            this.loader = false;
        }, 3000);
        
    }

}

}
</script>


<style scoped>
.no-wrap {
  white-space: nowrap;
}

.table td {
  white-space: nowrap;
}
.table-container {
    overflow-y: none;
max-height: calc(100vh - 100px);
}

.wrap-text {
    white-space: normal;        /* allow wrapping */
    word-break: break-word;     /* break long words */
    max-width: 200px;           /* adjust as needed */
}
</style>